// extracted by mini-css-extract-plugin
module.exports = {"slides":"tcSSb","withVideo":"PBSh1","withoutVideo":"R8Vo2","slidersContainer":"uoDht"};